document.addEventListener('DOMContentLoaded', () => {
  const newDiv = document.getElementById('store_products_bulk_new');
  if (newDiv == null) {
    return;
  }

  const includedTaxRadioButtonTrue = document.getElementById(
    'staff_store_product_bulk_confirmation_form_included_tax_true',
  ) as HTMLInputElement;
  const includedTaxRadioButtonFalse = document.getElementById(
    'staff_store_product_bulk_confirmation_form_included_tax_false',
  ) as HTMLInputElement;
  const taxRateRadioButton008 = document.getElementById(
    'staff_store_product_bulk_confirmation_form_tax_rate_0_08',
  ) as HTMLInputElement;
  const taxRateRadioButton010 = document.getElementById(
    'staff_store_product_bulk_confirmation_form_tax_rate_0_1',
  ) as HTMLInputElement;
  const roundTypeRadioButtonDefalut = document.getElementById(
    'staff_store_product_bulk_confirmation_form_round_type'
  ) as HTMLInputElement;
  const roundTypeRadioButtonRoundUp = document.getElementById(
    'staff_store_product_bulk_confirmation_form_round_type_round_up'
  ) as HTMLInputElement;
  const roundTypeRadioButtonRoundDown = document.getElementById(
    'staff_store_product_bulk_confirmation_form_round_type_round_down'
  ) as HTMLInputElement;
  const roundTypeRadioButtonRound = document.getElementById(
    'staff_store_product_bulk_confirmation_form_round_type_round'
  ) as HTMLInputElement;

  const toggleTaxRateRadioButtons = () => {
    const label = (taxRateRadioButton008 as HTMLElement).parentElement;
    const parentDiv = (label as HTMLElement).parentElement;
    const formGroup = (parentDiv as HTMLElement).parentElement;
    if (includedTaxRadioButtonFalse.checked && !includedTaxRadioButtonFalse.disabled) {
      (formGroup as HTMLElement).style.display = 'block';
      taxRateRadioButton008.disabled = false;
      taxRateRadioButton010.disabled = false;
    } else {
      (formGroup as HTMLElement).style.display = 'none';
      taxRateRadioButton008.disabled = true;
      taxRateRadioButton010.disabled = true;
    }
  }

  const toggleRoundTypeRadioButtons = () => {
    const label = (roundTypeRadioButtonDefalut as HTMLElement).parentElement;
    const parentDiv = (label as HTMLElement).parentElement;
    const formGroup = (parentDiv as HTMLElement).parentElement;
    if (includedTaxRadioButtonFalse.checked && !includedTaxRadioButtonFalse.disabled) {
      (formGroup as HTMLElement).style.display = 'block';
      roundTypeRadioButtonDefalut.disabled = false;
      roundTypeRadioButtonRoundUp.disabled = false;
      roundTypeRadioButtonRoundDown.disabled = false;
      roundTypeRadioButtonRound.disabled = false;
    } else {
      (formGroup as HTMLElement).style.display = 'none';
      roundTypeRadioButtonDefalut.disabled = true;
      roundTypeRadioButtonRoundUp.disabled = true;
      roundTypeRadioButtonRoundDown.disabled = true;
      roundTypeRadioButtonRound.disabled = true;
    }
  }

  includedTaxRadioButtonTrue.addEventListener('change', () => {
    toggleTaxRateRadioButtons();
    toggleRoundTypeRadioButtons();
  });
  includedTaxRadioButtonFalse.addEventListener('change', () => {
    toggleTaxRateRadioButtons();
    toggleRoundTypeRadioButtons();
  });
});
